export default {
    SERVICE_ID: 'service_tz38j8h',
    USER_ID: 'user_S2jgomFhJES4esvCygOQV',
    TEMPLATE_ID: 'template_p0cwal7',
    GA_TRACKING_ID: 'UA-194364001-1'
}